<template>
  <section class="report-wrapper" id="pdf-content">
    <b-card no-body v-if="reportData" style="min-height: 0;">
      <table class="w-100">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <b-card-body class="report_header w-100 pb-0">
                  <div class="company">
                    <h3 class="mb-1 text-left colorBlack">
                      {{ userData.company_name_cn }}
                    </h3>
                  </div>
                  <div class="title d-flex justify-content-between">
                    <!-- <h5 class="mb-0 colorBlack">供款表</h5> -->
                     <p></p>
                    <label>列印時間：{{ getDateTime() }}</label>
                  </div>
                  <div class="info my-50">
                    <b-row>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="12">
                            <h3>Repayment Schedule 供款表：</h3>
                          </b-col>

                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Name of Borrower 借款人姓名</b></b-col>
                                <b-col cols="6">：{{ reportData.name_cn }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6"></b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Loan No. 貸款編號</b></b-col>
                                <b-col cols="6">：{{ reportData.contract_number }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Loan Date 起息日期</b></b-col>
                                <b-col cols="6">：{{ reportData.loan_date }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Loan Amount 貸款金額</b></b-col>
                                <b-col cols="6">：{{ reportData.amount }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Interest Method 計息方法</b></b-col>
                                <b-col cols="6">：{{ reportData.interest_type.name }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Total Tenors 供款期数</b></b-col>
                                <b-col cols="6">：{{ reportData.period }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                                <b-col cols="6"><b>Repay. Cycle 供款週期</b></b-col>
                                <b-col cols="6">：{{ reportData.is_monthly ? '月供' : '半月供' }}</b-col>
                            </b-row>
                          </b-col>


                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b-card-body class="py-0 report_content w-100">
                <table class="report-table w-100">
                    <thead>
                      <tr>
                        <th>期數</th>
                        <th>供款日期</th>
                        <th>年利率</th>
                        <th>應還本金</th>
                        <th>應還利息</th>
                        <th>供欬金額</th>
                        <th>尚欠本金</th>
                      </tr>
                    </thead>
                  <tbody>
                    <tr v-for="item of reportData.payment_schedules" :key="item.id">
                      <th>{{ item.period }}</th>
                      <th>
                        {{
                          item.pay_date
                        }}
                      </th>
                      <th>
                        {{ reportData.annual_interest_rate }}
                      </th>
                     
                      <th>{{ formatCurrency(item.principal) }}</th>
                      <th>{{ formatCurrency(item.interest) }}</th>
                      <th>{{ formatCurrency(item.payment_amount) }}</th>
                      <th>
                        {{
                          formatCurrency(
                            Number(item.remaining_principal)
                          )
                        }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>

      <b-card-body class="report_footer py-0">
        <table class="report-table">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th>
                {{
                  formatCurrency(
                    reportData.payment_schedules.reduce(
                      (acc, curr) => acc + Number(curr.principal),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportData.payment_schedules.reduce(
                      (acc, curr) => acc + Number(curr.interest),
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  formatCurrency(
                    reportData.payment_schedules.reduce(
                      (acc, curr) => acc + Number(curr.payment_amount),
                      0
                    )
                  )
                }}
              </th>
              <th></th>
            </tr>
          </tfoot>
        </table>
        
      </b-card-body>
    </b-card>
    <div v-else >
    <b
        v-if="loading"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner small class="mr-1"></b-spinner>
        載入中...
      </b>
      <b v-else class="d-flex justify-content-center"
        >沒有過濾或沒有符合條件的數據</b
      >
    </div>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText, BSpinner } from "bootstrap-vue";


export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner
  },
  props: {
    reportData: {
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
.report_content .report-table, .report_footer .report-table {
  th {
    width: 100px;
    padding: 0 2px;
    // &:nth-child(1),
    // &:nth-child(2),
    // &:nth-child(3),
    // &:nth-child(4) {
    //   width: 110px;
    // }
  }
}
</style>